import * as React from 'react'

import { useLocation } from 'react-router-dom'
import { useRecoilValue } from 'recoil'
import useSWR from 'swr'

import URI from '../../../misc/classes/URI'
import { IPressResponse } from '../../../models/Press'
import routes from '../../../router/routes'
import { locale } from '../../../state/locale/atoms/locale'
import { translate } from '../../../state/locale/selectors/translate'
import { Flex } from '../../_layout/Flex'
import PageWrapper from '../../_layout/PageWrapper'
import Breadcrumbs from '../../reusable/Breadcrumbs'
import { HorizontalCard } from '../../reusable/HorizontalCard'
import { Loading } from '../../reusable/Loading'

const PressSinglePage = () => {
  const i18n = useRecoilValue(translate).press
  const breadcrumbs = [
    {
      link: routes.press,
      title: i18n.breadcrumb,
    },
  ]
  const lang = useRecoilValue(locale)
  const { pathname } = useLocation()
  const slug = pathname.split('/', 3)[2]
  const { data, isValidating } = useSWR<IPressResponse>(URI.getPressSingleUri(slug, lang))

  return (
    <PageWrapper>
      <Breadcrumbs base={breadcrumbs} />
      {isValidating && <Loading />}
      <Flex>
        {data?.data[0]?.articles
          ?.sort((a, b) => (a.date > b.date ? -1 : 1))
          .map((article) => (
            <HorizontalCard
              date={article.date}
              description={article.description}
              link={article.externalLink}
              linkBlank={true}
              image={article.image.provider_metadata.public_id}
              publisher={article.publisher}
              title={article.title}
              key={article.title}
            />
          ))}
      </Flex>
    </PageWrapper>
  )
}

export default PressSinglePage
